import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * useMedia — one-shot fetch of admin-uploaded photography.
 * Returns { media, url(id) } where media is a keyed dict and url(id) is a fallback-safe helper.
 */
export function useMedia() {
  const [media, setMedia] = useState({});
  useEffect(() => {
    axios.get(`${API}/media/services`).then((r) => {
      const raw = r.data.media || {};
      const base = process.env.REACT_APP_BACKEND_URL;
      const out = {};
      for (const [k, v] of Object.entries(raw)) {
        out[k] = v.startsWith("http") ? v : `${base}${v}`;
      }
      setMedia(out);
    }).catch(() => {});
  }, []);
  return {
    media,
    url: (id) => media[id] || null,
  };
}
